import(/* webpackMode: "eager" */ "/home/runner/work/sairishikreddy.io/sairishikreddy.io/app/(root)/page.tsx");
